module.exports = __webpack_public_path__ + "static/media/us_flag_2.942de8c8.png";